import React from "react"
import { StoreProvider } from "./src/context/store-context"
import { InterfaceProvider } from "./src/context/interface-context"
import { ThemeProvider } from "./src/theme"
import CookieConsentBanner from "./src/components/cookie"
import { withPrefix, Script } from "gatsby"
import QueryRootElement from "./query-root-element"
import { AccountProvider } from "./src/context/AccountContext"
import { routes } from "./src/routes"
import "./src/styles/global.css"
import { GlobalModalsProvider } from "./src/context/GlobalModalsContext"

export const wrapRootElement = ({ element }) => {
  const pathname = window.location.pathname

  return (
    <QueryRootElement>
      <ThemeProvider>
        <GlobalModalsProvider>
          <InterfaceProvider>
            <StoreProvider>
              {process.env.GATSBY_MESSENGER_SCRIPT_NAME && (
                <Script
                  src={withPrefix(process.env.GATSBY_MESSENGER_SCRIPT_NAME)}
                />
              )}
              <AccountProvider>{element}</AccountProvider>
              {!pathname.includes(routes.cardForm) && <CookieConsentBanner />}
            </StoreProvider>
          </InterfaceProvider>
        </GlobalModalsProvider>
      </ThemeProvider>
    </QueryRootElement>
  )
}
